import { Host, h } from '@stencil/core';
export class AibaTag {
  constructor() {
    this.handleClickTagButton = event => {
      const eventDetails = {
        event: event,
        heading: this.selfieAttributeDetails.heading,
        description: this.selfieAttributeDetails.description,
      };
      this.infoSelfieAttributeClicked.emit(eventDetails);
      this.handlers && this.handlers.handleClickTagButton && this.handlers.handleClickTagButton(eventDetails);
      this.handleTagClick && this.handleTagClick(event);
    };
    this.handlers = undefined;
    this.data = undefined;
    this.handleTagClick = undefined;
    this.selfieAttributeDetails = undefined;
    this.textDetails = {
      attribute: '',
      detail: '',
    };
  }
  render() {
    var _a, _b;
    return (h(Host, null, this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((element, index) => {
        var _a, _b, _c, _d;
        if (element && element['name'] === 'aiba-label' && element['_id'] === 'attribute') {
          return h("aiba-label", Object.assign({}, element['data'], { text: ((_a = this.textDetails) === null || _a === void 0 ? void 0 : _a.attribute) ? (_b = this.textDetails) === null || _b === void 0 ? void 0 : _b.attribute : element['data']['text'], _id: `attribute-${index}` }));
        }
        if (element && element['name'] === 'aiba-label' && element['_id'] === 'detail') {
          return h("aiba-label", Object.assign({}, element['data'], { text: ((_c = this.textDetails) === null || _c === void 0 ? void 0 : _c.detail) ? (_d = this.textDetails) === null || _d === void 0 ? void 0 : _d.detail : element['data']['text'], _id: `detail-${index}` }));
        }
        if (element && element['name'] === 'aiba-button') {
          return h("aiba-button", Object.assign({}, element['data'], { handleClick: (e) => this.handleClickTagButton(e) }));
        }
      }))));
  }
  static get is() { return "aiba-tag"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-tag.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-tag.css"]
    };
  }
  static get properties() {
    return {
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handleTagClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-tag-click",
        "reflect": false
      },
      "selfieAttributeDetails": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selfie-attribute-details",
        "reflect": false
      },
      "textDetails": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ attribute: string; detail: string; }",
          "resolved": "{ attribute: string; detail: string; }",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "{\n    attribute: '',\n    detail: '',\n  }"
      }
    };
  }
  static get events() {
    return [{
        "method": "infoSelfieAttributeClicked",
        "name": "infoSelfieAttributeClicked",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
}
//# sourceMappingURL=aiba-tag.js.map
